import axios from 'axios';
import contentSort from '@/app/utils/contentSortingUtil';

import {
  SET_STORAGE_SPACE,
  SET_SETUP_PASSWORD_STATUS,
  SET_ARCHIVE_DELETION_STATUS,
  SET_CONTENT_ITEMS,
  SET_FETCH_STORAGE_SPACE_STATUS,
  SET_FETCH_CONTENT_ITEMS_STATUS,
  SET_ACTIVE_CONTENT_TYPE,
  SET_APP_FEATURES,
  SET_FILE_VERSIONS,
  SET_FETCH_FILE_VERSIONS_STATUS,
  SET_SIGN_FILE_LINK,
  SET_SIGN_FILE_STATUS,
  SET_SEARCH_ENABLED_SATE,
  SET_SEARCH_RESULT_RECEIVED,
  SET_ACTIVE_VERSION_PATH,
  SET_ACTIVE_VOLUME_PATH,
  SET_ACTIVE_FOLDER_ITEM,
  SET_FETCH_CONTAINER_ITEMS_STATUS,
  SET_MACHINES,
  SET_BACKUPS,
  SET_INCOMPLETE_BACKUPS,
  SET_INCOMPLETE_BACKUPS_COUNT,
  SET_INCOMPLETE_BACKUPS_SIZE,
  SET_TOTAL_USED_SPACE,
  SET_ACTIVE_MACHINE_ID,
  SET_ACTIVE_MACHINE_DISPLAY_NAME,
  SET_FETCH_BACKUPS_STATUS,
  SET_ACTIVE_BACKUP_ID,
  SET_ACTIVE_BACKUP_DISPLAY_NAME,
  SET_DELETE_ALL_INCOMPLETE_STATUS,
  SET_DISPLAY_USER_NAME
} from './mutation-types';

import {
  FETCH_STORAGE_SPACE,
  SETUP_ARCHIVE_PASSWORD,
  RESET_ARCHIVE_PASSWORD_STATUS,
  DELETE_ARCHIVE,
  RESET_ARCHIVE_DELETION_STATUS,
  FETCH_CONTENT_ITEMS,
  SEARCH_CONTENT_ITEMS,
  UPDATE_ACTIVE_CONTENT_TYPE,
  FETCH_FILE_VERSIONS,
  SIGN_FILE,
  RESET_SIGN_FILE_STATUS,
  UPDATE_ACTIVE_VERSION_PATH,
  UPDATE_ACTIVE_VOLUME_PATH,
  SORT_CONTENT_ITEMS,
  FETCH_CONTAINER_ITEMS,
  UPDATE_ACTIVE_MACHINE,
  FETCH_MACHINE_BACKUPS,
  UPDATE_ACTIVE_BACKUP,
  FETCH_WR_CONFIG,
  DELETE_ALL_INCOMPLETE_BACKUPS
} from './action-types';

import {
  PENDING_STATUS,
  SUCCESS_STATUS,
  ERROR_STATUS,
  COMPLETED_STATUS,
  UNDEFINED_STATUS
} from './action-status';

import {
  MACHINE_TABLE_TYPE,
  BACKUP_TABLE_TYPE,
  INCOMPLETE_BACKUP_TABLE_TYPE,
  CONTENT_TABLE_TYPE,
  UNDEFINED_CONTENT_TYPE
} from './active-content-type';

const defaultSortOptions = { columnName: 'displayName', sortOrder: 'ascending' };
let contentTableSortOptions = defaultSortOptions;

const debug = process.env.NODE_ENV !== 'production';

export default {
  async [FETCH_CONTAINER_ITEMS]({ commit }) {
    commit(SET_FETCH_CONTAINER_ITEMS_STATUS, PENDING_STATUS);
    commit(SET_MACHINES, []);
    commit(SET_INCOMPLETE_BACKUPS, []);
    commit(SET_INCOMPLETE_BACKUPS_COUNT, 0);
    commit(SET_INCOMPLETE_BACKUPS_SIZE, 0);
    commit(SET_TOTAL_USED_SPACE, 0);
    commit(SET_DISPLAY_USER_NAME, '');

    await axios.get('/containers')
      .then(function (response) {
        if (response.data.machines !== undefined &&
            response.data.machines != null) {
          commit(SET_MACHINES, response.data.machines);
        }

        if (response.data.incompleteBackups !== undefined &&
            response.data.incompleteBackups != null) {
          commit(SET_INCOMPLETE_BACKUPS, response.data.incompleteBackups);
        }

        if (response.data.incompleteBackupsCount !== undefined &&
            response.data.incompleteBackupsCount != null) {
          commit(
            SET_INCOMPLETE_BACKUPS_COUNT,
            parseInt(response.data.incompleteBackupsCount, 10)
          );
        }

        if (response.data.incompleteBackupsSize !== undefined &&
            response.data.incompleteBackupsSize != null) {
          commit(
            SET_INCOMPLETE_BACKUPS_SIZE,
            parseInt(response.data.incompleteBackupsSize, 10)
          );
        }

        if (response.data.totalUsedSpace !== undefined &&
          response.data.totalUsedSpace != null) {
          commit(
            SET_TOTAL_USED_SPACE,
            parseInt(response.data.totalUsedSpace, 10)
          );
        }

        if (response.data.displayUserName !== undefined) {
          commit(SET_DISPLAY_USER_NAME, response.data.displayUserName);
        }
      }).finally(function () {
        commit(SET_FETCH_CONTAINER_ITEMS_STATUS, UNDEFINED_STATUS);
      });
  },
  async [FETCH_MACHINE_BACKUPS]({ commit }, selectedMachine) {
    commit(SET_FETCH_BACKUPS_STATUS, PENDING_STATUS);
    commit(SET_BACKUPS, []);

    await axios.get('/machineBackups', {
      params: {
        machineId: selectedMachine.machineId
      }
    }).then(function (response) {
      let backups = [];
      if (debug) {
        backups = response.data[0] !== undefined ? response.data[0].data : [];
      } else {
        backups = response.data;
      }

      commit(SET_BACKUPS, backups);
    }).finally(function () {
      commit(SET_FETCH_BACKUPS_STATUS, UNDEFINED_STATUS);
    });
  },
  async [FETCH_WR_CONFIG]({ commit }) {
    await axios.get('/wrConfig')
      .then(function (response) {
        commit(SET_APP_FEATURES, response.data.appFeatures);
      });
  },
  async [FETCH_STORAGE_SPACE]({ commit }) {
    commit(SET_FETCH_STORAGE_SPACE_STATUS, PENDING_STATUS);
    await axios.get('/space')
      .then(function (response) {
        commit(SET_STORAGE_SPACE, response.data);
      }).finally(function () {
        commit(SET_FETCH_STORAGE_SPACE_STATUS, UNDEFINED_STATUS);
      });
  },
  async [SETUP_ARCHIVE_PASSWORD]({ commit, dispatch }, setupPasswordForm) {
    commit(SET_SETUP_PASSWORD_STATUS, PENDING_STATUS);
    if (debug) {
      await setTimeout(function () {
        if (setupPasswordForm.password === '123') {
          commit(SET_SETUP_PASSWORD_STATUS, SUCCESS_STATUS);
        } else {
          commit(SET_SETUP_PASSWORD_STATUS, ERROR_STATUS);
        }
      }, 1200);
    } else {
      await axios.put('/password', setupPasswordForm)
        .then(function () {
          commit(SET_SETUP_PASSWORD_STATUS, SUCCESS_STATUS);
        }).catch(function (error) {
          if (error.response) {
            if (error.response.status === 403) {
              commit(SET_SETUP_PASSWORD_STATUS, ERROR_STATUS);
            } else if (error.response.status !== 200) {
              commit(SET_SETUP_PASSWORD_STATUS, UNDEFINED_STATUS);
            }
          }
        });
    }
  },
  [RESET_ARCHIVE_PASSWORD_STATUS]({ commit }) {
    commit(SET_SETUP_PASSWORD_STATUS, UNDEFINED_STATUS);
  },
  async [DELETE_ARCHIVE]({ commit, dispatch }, archiveId) {
    commit(SET_ARCHIVE_DELETION_STATUS, PENDING_STATUS);
    await axios.delete('/boxes', {
      params: {
        id: archiveId
      }
    }).finally(function () {
      commit(SET_ARCHIVE_DELETION_STATUS, COMPLETED_STATUS);
    });
  },
  [RESET_ARCHIVE_DELETION_STATUS]({ commit }) {
    commit(SET_ARCHIVE_DELETION_STATUS, UNDEFINED_STATUS);
  },
  [UPDATE_ACTIVE_VERSION_PATH]({ commit, dispatch }, activeVersionPath) {
    commit(SET_ACTIVE_VERSION_PATH, activeVersionPath);
  },
  [UPDATE_ACTIVE_VOLUME_PATH]({ commit, dispatch }, activeVolumePath) {
    commit(SET_ACTIVE_VOLUME_PATH, activeVolumePath);
  },
  async [FETCH_CONTENT_ITEMS]({ commit, dispatch }, selectedItem) {
    commit(SET_SEARCH_RESULT_RECEIVED, false);
    commit(SET_FETCH_CONTENT_ITEMS_STATUS, PENDING_STATUS);
    commit(SET_CONTENT_ITEMS, []);

    if (selectedItem.path === '') {
      commit(SET_ACTIVE_VERSION_PATH, '');
      commit(SET_ACTIVE_VOLUME_PATH, '');
      contentTableSortOptions = defaultSortOptions;
    }

    await axios.get('/content', {
      params: {
        archiveId: selectedItem.archiveId,
        path: selectedItem.path
      }
    }).then(function (response) {
      commit(SET_ACTIVE_FOLDER_ITEM, {
        path: selectedItem.path,
        displayName: selectedItem.path === '' ? '' : selectedItem.displayName,
        isSearchFolder: false
      });

      let content = [];
      if (debug) {
        content = response.data[0] !== undefined ? response.data[0].data : [];
      } else {
        content = response.data.data;
      }

      dispatch(SORT_CONTENT_ITEMS, {
        items: content,
        columnName: contentTableSortOptions.columnName,
        sortOrder: contentTableSortOptions.sortOrder
      });

      const isSearchable = content.length > 0 ?
        (content[0].itemGroup !== 'version' && content[0].itemGroup !== 'volume') : false;

      commit(SET_SEARCH_ENABLED_SATE, isSearchable);
    }).finally(function () {
      commit(SET_FETCH_CONTENT_ITEMS_STATUS, UNDEFINED_STATUS);
    });
  },
  async [SEARCH_CONTENT_ITEMS]({ commit, dispatch }, selectedItem) {
    commit(SET_FETCH_CONTENT_ITEMS_STATUS, PENDING_STATUS);
    commit(SET_CONTENT_ITEMS, []);

    // hack to show path column in the content table in correct order
    commit(SET_ACTIVE_CONTENT_TYPE, UNDEFINED_CONTENT_TYPE);
    commit(SET_SEARCH_RESULT_RECEIVED, true);
    await new Promise(resolve => setTimeout(resolve, 200));
    commit(SET_ACTIVE_CONTENT_TYPE, CONTENT_TABLE_TYPE);

    await axios.get('/search', {
      params: {
        archiveId: selectedItem.archiveId,
        volumePath: selectedItem.volumePath,
        path: selectedItem.path,
        searchText: selectedItem.searchText
      }
    }).then(function (response) {
      commit(SET_ACTIVE_FOLDER_ITEM, {
        path: selectedItem.path,
        displayName: selectedItem.searchText,
        isSearchFolder: true
      });

      const content = debug ? response.data : response.data.data;

      dispatch(SORT_CONTENT_ITEMS, {
        items: content,
        columnName: contentTableSortOptions.columnName,
        sortOrder: contentTableSortOptions.sortOrder
      });
    }).finally(function () {
      commit(SET_FETCH_CONTENT_ITEMS_STATUS, UNDEFINED_STATUS);
    });
  },
  [UPDATE_ACTIVE_CONTENT_TYPE]({ commit }, activeContentType) {
    commit(SET_SEARCH_ENABLED_SATE, false);

    if (activeContentType === MACHINE_TABLE_TYPE) {
      commit(SET_ACTIVE_MACHINE_ID, '');
      commit(SET_ACTIVE_MACHINE_DISPLAY_NAME, '');

      commit(SET_ACTIVE_BACKUP_ID, '');
      commit(SET_ACTIVE_BACKUP_DISPLAY_NAME, '');
    }

    if (activeContentType === BACKUP_TABLE_TYPE
      || activeContentType === INCOMPLETE_BACKUP_TABLE_TYPE) {
      commit(SET_ACTIVE_BACKUP_ID, '');
      commit(SET_ACTIVE_BACKUP_DISPLAY_NAME, '');
    }

    commit(SET_ACTIVE_CONTENT_TYPE, activeContentType);
  },
  [UPDATE_ACTIVE_MACHINE]({ commit }, activeMachine) {
    commit(SET_ACTIVE_MACHINE_ID, activeMachine.machineId);
    commit(SET_ACTIVE_MACHINE_DISPLAY_NAME, activeMachine.displayName);
  },
  [UPDATE_ACTIVE_BACKUP]({ commit }, activeBackup) {
    commit(SET_ACTIVE_BACKUP_ID, activeBackup.activeBackupId);
    commit(SET_ACTIVE_BACKUP_DISPLAY_NAME, activeBackup.activeBackupDisplayName);
  },
  async [FETCH_FILE_VERSIONS]({ commit, dispatch }, selectedItem) {
    commit(SET_FETCH_FILE_VERSIONS_STATUS, PENDING_STATUS);
    commit(SET_FILE_VERSIONS, []);
    await axios.get('/versions', {
      params: {
        archiveId: selectedItem.archiveId,
        path: selectedItem.path
      }
    }).then(function (response) {
      const sortedData = response.data.sort((a, b) => b.id - a.id);
      commit(SET_FILE_VERSIONS, sortedData);
    }).finally(function () {
      commit(SET_FETCH_FILE_VERSIONS_STATUS, UNDEFINED_STATUS);
    });
  },
  async [SIGN_FILE]({ commit, dispatch }, selectedItem) {
    commit(SET_SIGN_FILE_STATUS, PENDING_STATUS);
    await axios.get('/asign', {
      params: {
        archiveId: selectedItem.archiveId,
        path: selectedItem.path,
        ver: selectedItem.fileVersion
      }
    }).then(function (response) {
      commit(SET_SIGN_FILE_LINK, response.data.link);
      commit(SET_SIGN_FILE_STATUS, COMPLETED_STATUS);
    });
  },
  [RESET_SIGN_FILE_STATUS]({ commit }) {
    commit(SET_SIGN_FILE_STATUS, UNDEFINED_STATUS);
  },
  [SORT_CONTENT_ITEMS]({ commit, dispatch }, data) {
    contentTableSortOptions = {
      columnName: data.columnName,
      sortOrder: data.sortOrder
    };
    const sortedItems = contentSort(data.items, data.columnName, data.sortOrder);
    commit(SET_CONTENT_ITEMS, sortedItems);
  },
  async [DELETE_ALL_INCOMPLETE_BACKUPS]({ commit }, usedSize) {
    commit(SET_DELETE_ALL_INCOMPLETE_STATUS, PENDING_STATUS);
    await axios.delete('/incompleteBackups')
      .then(function (response) {
        commit(SET_TOTAL_USED_SPACE, (usedSize.totalUsedSpace - usedSize.incompleteBackupsSize));
      }).finally(function () {
        commit(SET_DELETE_ALL_INCOMPLETE_STATUS, COMPLETED_STATUS);
        commit(SET_INCOMPLETE_BACKUPS, []);
        commit(SET_INCOMPLETE_BACKUPS_COUNT, 0);
        commit(SET_INCOMPLETE_BACKUPS_SIZE, 0);
      });
  }
};
